import { RecurrenceType } from './types';

export const RECURRENCE_OPTIONS = [
  { value: RecurrenceType.WEEKLY, label: 'Weekly' },
  { value: RecurrenceType.SPECIFIC_DATE, label: 'Specific Date' },
  { value: RecurrenceType.CUSTOM, label: 'Custom' },
];

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const MIN_INTERVAL_UNITS = 1;
export const MAX_INTERVAL_UNITS = 31;

export const TIME_UNIT_OPTIONS = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
];
